import { Component } from '@angular/core';

import { Platform, NavController } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { TranslateService } from '@ngx-translate/core';
import { SettingsService } from './settings.service';
import { AdMobFree } from '@ionic-native/admob-free/ngx';
import { UtilService } from './util.service';
import { Storage } from '@ionic/storage';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent {
  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    private translate: TranslateService,
    private settings: SettingsService,
    private admob: AdMobFree,
    private storage: Storage,
    private router: Router,
    private navigate: NavController
  ) {
    this.initializeApp();
  }

  initializeApp() {
    this.platform.ready().then(() => {
      if (this.platform.is('android')) {
        this.statusBar.backgroundColorByHexString('#000000');
      } else {
        this.statusBar.styleDefault();
      }
      this.splashScreen.hide();
      this.initTranslate();
      if (this.platform.is('cordova')) {
        this.initAds();
      }
      if (this.platform.is('android')) {
        this.initBackEvent();
      }
    });
  }

  initTranslate() {
    this.translate.addLangs(SettingsService.LANGUAGES);
    this.translate.setDefaultLang(SettingsService.DEFAULT_LANG);
    this.translate.use(this.settings.getLanguage());
    this.settings.getCurrency();
  }

  initAds() {
    this.storage.get('inv_r_ads').then(res => {
      if (res !== true) {
        this.loadBanner();
      }
    }).catch(() => this.loadBanner());
  }

  loadBanner() {
    this.admob.banner.config({
      id: this.platform.is('android') ? UtilService.ANDROID_BANNER : UtilService.IOS_BANNER,
      autoShow: true,
      isTesting: UtilService.TEST_ADS
     });

     // Create banner
     this.admob.banner.prepare();  
  }

  initBackEvent() {
    this.platform.backButton.subscribe(() => {
      if (this.router.url == '/tabs/tab1') {
        navigator['app'].exitApp();
      } else {
        this.navigate.back();
      }
    });
  }
}
